import {styled} from '@mui/material/styles';

import 'github-markdown-css/github-markdown-dark.css'
import {
    Card,
    TextM,
    WhiteSpace,
    Button,
    TextS,
    LoadingBlock,
} from '../../components'
import Container from '@mui/material/Container';
import Drawer from '@mui/material/Drawer';

import useLanguage from '../../hook/useLanguage'

import { useState, useRef, useEffect } from 'react';
import { Stack } from '@mui/material';

import {
    useProtocal,
} from '../../hook/silver/useProtocal'

import { useTranslation } from 'react-i18next'
import locales from '../../locales/index.json' 
import snarkdown from 'snarkdown'

import {
    useSwitchInput
} from '../../hook/useInput'

const _lang = {}
async function GetProtocolMD(lang) {
    if(!_lang[lang]) {
        const md = await import('./'+lang.toLocaleUpperCase()+'.md')
        _lang[lang] = md.default || md
    }
    return _lang[lang]
}


async function hashOfProtocalWithLanguage(centext) {
    const encoder = new TextEncoder();
    const data = encoder.encode(centext);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    console.log(
        hashHex
    )

    return hashHex
}


const config = {
    "en" : {
        hash: "0xcb7a698ee0056ebe9981231476479bddb069a9c39d20efa0969f30ba7e88b40d"
    },
    "ja" : {
        hash: "0x08f9c0e4b7e18e9ecd2ff5ff03ac66b08503de1c0089640a78fd541dd6634924"
    },
    "ko" : {
        hash: "0x39d70195b6de5dba286c982121d1849add301fc8bf20c0f120384080c994b29a"
    },
    "ms" : {
        hash: "0xad3ed58da500937b600f3e32897a473e39a8571684c18deda8bfa7de83fe10a5"
    },
    "ru" : {
        hash: "0x74f3fe72bfa8959a5dc3d9bdb1a8965d8f739483aba6faa6e0c5c308b6820b27"
    },
    "th" : {
        hash: "0xd4ab89e381f6a14128fd46996a01d7946096d265b78252d572c0577182b4a0bf"
    },
    "vi" : {
        hash: "0xf1b13f1f69781e92909249411149c7548ff6c9aee7f6f32563e9e61526ee573d"
    },
    "zh" : {
        hash: "0x94430b2e8fb10ed8337d71ad9476168b95d2638fdf6c0c7a60346d3d59a7dc36"
    }

    // "繁": {
    //     button: "簽署上鏈",
    //     sub: "簽署上鏈操作會將協議 hash 簽名後永久保存到鏈上",
    //     back: "暫時跳過",
    //     content: CN,
    //     hash: '0xae1527fce9a3ead779c06c7974883d4a48ebb593b2c530a5b4c61b358dfce13d'
    // },
    // "EN": {
    //     button: "Sign On-Chain",
    //     sub: "The on-chain signing operation will permanently store the hashed and signed agreement on the blockchain.",
    //     content: EN,
    //     back: "Skip",
    //     hash: '0x6583816ad27df14cd2fcd5cfe971253eaa0368cc7f20230625bddd7620ddb4b7'
    // },
    // "TH": {
    //     button: "ลงนามบนบล็อกเชน",
    //     sub: "การลงนามบนบล็อกเชนจะบันทึกข้อตกลงที่ถูกแฮชและลงนามไว้บนบล็อกเชนอย่างถาวร",
    //     content: TH,
    //     back: "ข้ามชั่วคราว",
    //     hash: '0x1bed9a57aaff00aac82069c3b39b752104890af98b885b182457d6ba869ee774'
    // }
}

function MarkdownRenderer({ html }) {
  return (
    <MarkdownWrap
        className="markdown-body"
        dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}

function Index({cloes = () => {}, onComfirm}) {
    const {t} = useTranslation()
    const {
        lang,
        resources,
        checkoutLanguage
    } = useLanguage()
    
    const [html, setHtml] = useState(null)
    
    useEffect(() => {
        setHtml(null)
        GetProtocolMD(lang).then(e => {
            setHtml(snarkdown(e))
        })
    }, [lang])

    // useEffect(() => {
    //     const init = async () => {
    //         const call = await Promise.all(
    //             resources.map(v => GetProtocolMD(v).then(v => hashOfProtocalWithLanguage(v)))
    //         )

    //         const config = {}
    //         console.log(
    //             call.map((hash, i) => { 
    //                 config[resources[i]] = hash
    //                 return {
    //                     key: resources[i],
    //                     hash
    //                 }
    //             })
    //         )

    //         console.log(
    //             config
    //         )
    //     }
    //     init()
    // },[])

    // const {
    //     // button,
    //     sub,
    //     content: Content,
    //     back,
    //     // hash
    // } = config['EN']
    // const ref = useRef(null)
    const {hash} = config[lang]
    // const button = useSign(hash)


    // useEffect(() => {
    //     console.log(
    //         [ref.current.textContent]
    //     )
    //     async function init() {
    //         const encoder = new TextEncoder();
    //         const data = encoder.encode(ref.current.textContent);
    //         const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    //         const hashArray = Array.from(new Uint8Array(hashBuffer));
    //         const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    //         console.log(
    //             hashHex
    //         )
    //     }
    //      init()
    // },[])


    return (
        <>
            <Container sx={{paddingBottom:'80px', background:'#24262f'}}>
                <WhiteSpace />
                {/* <div style={{textAlign:'center'}}>
                    {
                        resources.map(v =>
                            <TextM
                                key={v}
                                style={{
                                    padding: '8px 16px',
                                    // width: '20%'
                                }}
                                color={lang === v ? 1 : 2}
                                onClick={() => {
                                    checkoutLanguage(v)
                                }}
                            >{locales.languageList[v].name}</TextM>
                        )
                    }
                </div>
                <WhiteSpace /> */}
                <Card>
                    <LoadingBlock
                        loading={html === null}
                        // loading={true}
                        style={{padding: '280px 0px'}}
                    >
                        <MarkdownRenderer html={html} />
                    </LoadingBlock>
                </Card>
                <WhiteSpace size='2'/>
            </Container>
            <FootWrap>
                <FootFixed>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                    >
                        <Button
                            style={{width: '64%'}}
                            onClick={() => {
                                cloes()
                                onComfirm(hash)
                            }}
                        >{t('Agree')}</Button>
                        <Button type='e' style={{width: '34%'}} onClick={cloes}>{t('Skip')}</Button>
                    </Stack>
                    <TextS style={{display:'block',padding:'4 auto 16px'}}>{t('The on-chain signing operation will permanently store the hashed and signed agreement on the blockchain.')}</TextS>
                </FootFixed>
            </FootWrap>
        </> 
    )
}




export default Index
// export default withRouter(PageNav)

const FootWrap = styled('div')`
    width: 100%;
    height: 76px;
    position: relative;
`

const FootFixed = styled('div')`
    width: 100%;
    bottom: 0px;
    position: fixed;
    text-align: center;
    background: #3a3c45;
    padding: 10px 8px 14px;
    box-shadow: 0px -2px 5px #24262f;
`

export function CheckProtocal({children}) {
    const signed = useProtocal()
    const [open, setOpen] = useState(false);
    const cloes = () => {
        setOpen(false)
    }
    return (
        <div style={{position:'relative'}}>
            {
                signed &&
                <>
                    <ToProtocal onClick={() => {
                        setOpen(true)
                    }}/>
                    <Drawer
                        open={open}
                        anchor='bottom'
                    >
                        <Index cloes={cloes}/>
                    </Drawer> 
                </>
            }
            {children}
            
        </div>
    )
}

export function ProtocolSignDrawer({
    onComfirm = () => {},
    buttonStyle={}
}) {
    const switchInput = useSwitchInput()
    return (
        <>
            <Button {...buttonStyle} onClick={() => switchInput.onChange(true)} >Sign Investment Agreement</Button>
            <Drawer
                anchor='bottom'
                onClose={() => {
                    switchInput.onChange(false)
                }}
                open={switchInput.value}
            >
                <Index
                    cloes={switchInput.onChange}
                    onComfirm={hash => {
                        onComfirm(hash)
                    }}
                />
            </Drawer>
        </>
    )
}

const ToProtocal = styled('div')`
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 1;
`

const MarkdownWrap = styled('div')`
    &.markdown-body {
        background-color: #2d2f37;
        color: #f1f2fa;
    }
    /* &.markdown-body pre {

    } */

    /* &.markdown-body code {
        background-color: #2d2d2d;
        color: #c5c8c6;
    } */

    &.markdown-body a {
        color: #569cd6;
    }
    padding: 12px;
    a {
        pointer-events: none;
    }
`